import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { featuredAnime } from '@/mocks/anime';

export default function EditorPick() {
  const { t } = useTranslation();

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6">
          ⭐ {t('编辑精选')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {featuredAnime.map((anime) => (
            <Link
              key={anime.id}
              to={`/anime/${anime.id}`}
              className="group relative rounded-lg overflow-hidden aspect-[3/4] cursor-pointer"
            >
              <img
                src={anime.cover}
                alt={anime.title}
                title={`${anime.title} - 编辑精选`}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-white font-heading text-lg md:text-xl mb-1">{anime.title}</h3>
                <p className="text-white/70 text-sm">{anime.description}</p>
              </div>
              <div className="absolute top-3 left-3">
                <span className="bg-accent-500 text-white text-xs px-2.5 py-0.5 rounded-full whitespace-nowrap">
                  {t('高分神作')}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}